import { render, staticRenderFns } from "./ClientProfileHistory.vue?vue&type=template&id=5460bb40&scoped=true&"
import script from "./ClientProfileHistory.vue?vue&type=script&lang=js&"
export * from "./ClientProfileHistory.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileHistory.vue?vue&type=style&index=0&id=5460bb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460bb40",
  null
  
)

export default component.exports